import React from "react";
import heroImage from "../../../../assets/images/Landing_Page/hero_illustration.webp";
import { Link } from "react-router-dom";
export default function Hero() {
  return (
    <>
      <section className="hero-section" style={{ background: `#0A1128` }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* <span className="hero-badge">
                <span className="dot"></span>
                DISCOVER &rarr; CONNECT &rarr; START &rarr; TRADE &rarr; GROW
              </span> */}

             <h1 className="hero-title">
  Create Your Shop Showcase For Free In 5 Minutes Hire A Sales And Marketing Agent
  <br />
  <span className="accent">
    Connect With Thousands Of Local Clients And Grow Your Business
  </span>
</h1>

              <p className="hero-lead">
                The Global Business Resource &amp; Opportunity Ecosystem
              </p>
              <p className="hero-body">
                Discover products, services, businesses, suppliers,
                manufacturers, jobs, resources and opportunities, all
                connected through one ecosystem.
              </p>

              <p className="hero-cta-line">
            CONNECT YOUR SHOP WITH ALL BUSINESS RESOURCES TO GET DAILY UPDATES FOR YOUR GROWTH
              </p>

              <div className="d-flex flex-wrap gap-3 mt-4">
                <button
                  type="button"
                  className="btn-selectezi-primary"
                  disabled
                >
                  JOIN SELECTEZI
                </button>
                <Link to="/investment-opportunities" className="btn-selectezi-outline">
                  EXPLORE OPPORTUNITIES
                </Link>
              </div>

              <p className="hero-footnote">
                SELECTEZI is designed for people and businesses who want to
                discover what they need, present what they have, connect with
                the right resources, promote their capabilities and explore
                new business opportunities. SELECTEZI is more than a place to
                display products. It connects the people, businesses,
                resources and services behind everyday business activity.
              </p>
            </div>

            <div className="col-lg-6 hero-image mt-5 mt-lg-0">
              <img src={heroImage} alt="SELECTEZI ecosystem illustration" />
            </div>
          </div>
        </div>
      </section>

    
    </>
  );
}
